import { makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import { FC } from "react"
import { colors } from "../../utils/theme"
import { StaffOverviewData } from "../../utils/types"
import { CaseMixPieChart } from "./CaseMixPieChart"

const useStyles = makeStyles((theme) => ({
  staffOverview: {
    border: `1px solid ${colors.neutral.clay}`,
    borderRadius: 4,
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    marginBottom: theme.spacing(3),
    height: 169,
    alignItems: "center",
  },
  block: {
    width: 177,
    height: 105,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  count: {
    padding: 0,
    margin: 0,
    marginBottom: 4,
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: 56,
    lineHeight: "64px",
    letterSpacing: 0.3,
    color: colors.neutral.denim,
  },
  subtitle: {
    padding: 0,
    margin: 0,
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "14.4px",
    letterSpacing: 0.3,
    color: colors.neutral.asphalt,
  },
  title: {
    color: colors.neutral.asphalt,
  },
  section: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  innerSection: {
    borderRight: `1px solid ${colors.neutral.clay}`,
  },
}))

const Block: FC<{ count: number; title: string; subtitle: string }> = ({
  count,
  title,
  subtitle,
}) => {
  const classes = useStyles()
  return (
    <div className={classes.block}>
      <p className={classes.count}>{count}</p>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      <p className={classes.subtitle}>{subtitle}</p>
    </div>
  )
}

const StaffOverview: FC<{ staffOverviewData?: StaffOverviewData }> = ({
  staffOverviewData,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.staffOverview}>
      <div className={clsx(classes.section, classes.innerSection)}>
        <Block
          count={staffOverviewData?.viraClients ?? 0}
          title="Vira Clients"
          subtitle="total"
        />
      </div>
      <div className={clsx(classes.section, classes.innerSection)}>
        <Block
          count={staffOverviewData?.nudges ?? 0}
          title="Nudges"
          subtitle="total"
        />
      </div>
      <div className={clsx(classes.section, classes.innerSection)}>
        <Block
          count={staffOverviewData?.questionnaires ?? 0}
          title="Assessments"
          subtitle="total"
        />
      </div>
      <div className={classes.section}>
        <CaseMixPieChart />
      </div>
    </div>
  )
}

export default StaffOverview
